import React from 'react'
import ManageIpAddressContainer from './ManageIpAddressContainer'

const ManageIpAddress = (props) => (
  <ManageIpAddressContainer {...props} />
)

export default ManageIpAddress



// WEBPACK FOOTER //
// src/routes/ManageIpAddress/index.js